import React from 'react';
import PropTypes from 'prop-types';
import  {
    TableBody,
    TableCell,
    TableRow,
} from 'material-ui/Table';
import moment from 'moment';
import Checkbox from 'material-ui/Checkbox';
import { withStyles } from 'material-ui/styles';

const DEFAULT_DATE_FORMAT='DD-MMM-YYYY HH:mm:ss a'

const dateFormatDisplay=(dateVal,format)=>{
  return moment(dateVal).format(format?format:DEFAULT_DATE_FORMAT); 
}

let EnhancedTableBody = props => {
    const { data, page, rowsPerPage, totalRows,columnData, isSelectedFunc, handleClick, handleKeyDown, clientUiProps } = props;
    //const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);
    //{data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
    return (
      <TableBody>
        {data.map(n => {
          //const isSelected = isSelectedFunc(n.id);
          return (
            <TableRow
              hover
              onClick={event => handleClick(event, n.id)}
             // onKeyDown={event => handleKeyDown(event, n.id)}
              role="checkbox"
            //  aria-checked={isSelected}
              tabIndex={-1}
              key={n.id}
              selected={false}
              //selected={isSelected}
            >
             {/*
              <TableCell padding="checkbox">
                <Checkbox checked={isSelected} />
              </TableCell>
             */}
              {
                  columnData.map(col=> {
                      if (col.customCol){
                        return (
                            <TableCell 
                              key={col.id} 
                              padding={col.disablePadding?'none':'default'} 
                              numeric={col.numeric} 
                              style={col.style}
                              >{props.customColFunc(col,n,clientUiProps)}</TableCell>
                        )    
                      }
                      if (col.dateFormat){
                        const newDate = Date.parse(n[col.id]) 
                        
                        return (
                            <TableCell 
                              key={col.id} 
                              padding={col.disablePadding?'none':'default'} 
                              numeric={col.numeric} 
                              style={col.style}
                              >
                              {n[col.id]?dateFormatDisplay(newDate,col.dateFormat.format):''}
                              </TableCell>
                        )  
                      }
                      return (
                          <TableCell 
                            key={col.id} 
                            padding={col.disablePadding?'none':'default'} 
                            numeric={col.numeric}  style={col.style} >{n[col.id]}</TableCell>
                      )
                  })
              }
            </TableRow>
          );
        })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={6} />
          </TableRow>
        )}
      </TableBody>
    )
}

EnhancedTableBody.propTypes = {
    isSelectedFunc: PropTypes.func,
    rowsPerPage: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    columnData: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    handleClick: PropTypes.func,
    handleKeyDown: PropTypes.func
};

export default EnhancedTableBody;


// WEBPACK FOOTER //
// ./src/components/MaterialUi/DataTable/EnhancedTableBody.js